import { useEffect } from 'react'
import { X } from 'lucide-react'

/**
 * Modale autonome (Tailwind) pour l'espace admin.
 *
 * On n'utilise volontairement PAS components/ui/Modal ni les classes globales
 * `.modal`/`.modal-overlay` : celles-ci sont définies ailleurs en
 * `display:none; opacity:0` (visibles seulement avec `.active`) et rendraient
 * la modale invisible. Overlay Tailwind dédié, comme les modales déjà en place.
 */
export default function AdminModal({ isOpen, onClose, title, subtitle, footer, children, size = 'default' }) {
  useEffect(() => {
    if (!isOpen) return undefined
    const onKey = (e) => { if (e.key === 'Escape') onClose() }
    document.addEventListener('keydown', onKey)
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = ''
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  const maxWidth = size === 'lg' ? 'max-w-2xl' : 'max-w-md'

  return (
    <div
      className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm"
      onClick={(e) => { if (e.target === e.currentTarget) onClose() }}
      role="dialog"
      aria-modal="true"
    >
      <div className={`w-full ${maxWidth} overflow-hidden rounded-2xl border border-white/10 bg-[#0a0a0a] shadow-2xl`}>
        <div className="flex items-start justify-between gap-3 border-b border-white/10 px-5 py-4">
          <div>
            <h3 className="text-base font-semibold text-white">{title}</h3>
            {subtitle && <p className="mt-0.5 text-xs text-white/40">{subtitle}</p>}
          </div>
          <button
            onClick={onClose}
            type="button"
            aria-label="Fermer"
            className="rounded-lg p-1 text-white/40 transition hover:bg-white/10 hover:text-white"
          >
            <X size={18} />
          </button>
        </div>

        <div className="px-5 py-4">{children}</div>

        {footer && (
          <div className="flex justify-end gap-2 border-t border-white/10 px-5 py-4">{footer}</div>
        )}
      </div>
    </div>
  )
}
